import { render, staticRenderFns } from "./AddCategories.vue?vue&type=template&id=7449b5d5&scoped=true&"
import script from "./AddCategories.vue?vue&type=script&lang=js&"
export * from "./AddCategories.vue?vue&type=script&lang=js&"
import style0 from "./AddCategories.vue?vue&type=style&index=0&id=7449b5d5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7449b5d5",
  null
  
)

export default component.exports